import { SectionCard } from '@/Components/Layout';
import { Button } from '@/Components/Common/Buttons';

interface ErrorFallbackProps {
    error: unknown;
    componentStack: string;
    eventId: string;
    resetError: () => void;
}

export function ErrorFallback({
    error,
    resetError,
}: ErrorFallbackProps): React.JSX.Element {
    return (
        <div className="flex min-h-screen items-center justify-center p-4">
            <SectionCard title="Something went wrong" className="w-full max-w-md">
                <p className="text-sm text-muted-foreground">
                    An unexpected error occurred. Please try again or
                    return to the home page.
                </p>
                {import.meta.env.DEV && (
                    <pre className="mt-4 max-h-40 overflow-auto rounded bg-muted p-3 text-xs">
                        {error instanceof Error
                            ? error.message
                            : String(error)}
                    </pre>
                )}
                <div className="mt-6 flex gap-2">
                    <Button onClick={resetError}>Try Again</Button>
                    <Button
                        variant="outline"
                        onClick={() => {
                            window.location.href = '/';
                        }}
                    >
                        Go Home
                    </Button>
                </div>
            </SectionCard>
        </div>
    );
}
